import { FreidaRoles } from '../enums';
import { ProgramSearchResultModel, SavedSearchModel, SpecialtyModel } from '.';

export class UserModel {

  public get isMember() {
    return this.roles ? this.roles.indexOf(FreidaRoles.AmaMemberRole) > -1 || this.roles.indexOf('AMA Member') > -1 : false;
  }

  public get isAuthenticated(): boolean {
    return this.roles ? this.roles.indexOf(FreidaRoles.AuthenticatedUser) > -1 : false;
  }

  public get isProgramMaintainer() {
    return this.roles ? this.roles.indexOf(FreidaRoles.ProgramMaintainer) > -1 : false;
  }

  public uuid: string;
  public udp_internal_id: string;
  public email: string;
  public name: string;
  public roles: string[] = [];
  public savedSearches: SavedSearchModel[] = [];
  public savedPrograms: ProgramSearchResultModel[] = [];
  public aciSurveyResults: any[] = [];
  public rawResults: any[] = [];
  public aciSurveyDashboard: any[] = [];
  public life_stage: string;
  public tam_id: string;
  public member_status: string;
  public programDownloads: number;

  constructor(values?: Partial<UserModel>) {
    this.roles = [];
    this.name = "Sign In";
    Object.assign(this, values);
  }
}
